// src/pages/StatesPage.js
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Button,
  Spinner,
  Table,
  TableHead,
  TableHeadCell,
  TableRow,
  TableCell,
  TableBody,
  TextInput,
} from "flowbite-react";

import StateFormModal from "../components/states/StateFormModal";
import { statesActions, statesThunks } from "../app/store"; // <-- ajuste o path do store

export default function StatesPage() {
  const dispatch = useDispatch();

  const { items, count, status, error } = useSelector((s) => s.states);

  // se quiser manter q/limit local, ok
  const [q, setQ] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const limit = useMemo(() => 20, []);
  const offset = 0;

  useEffect(() => {
    dispatch(statesThunks.list({ q: "", limit, offset }));
  }, [dispatch, limit]);

  function openCreate() {
    setEditing(null);
    setModalOpen(true);
  }

  function openEdit(row) {
    setEditing(row);
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
    setEditing(null);
    dispatch(statesActions.clearError());
  }

  async function onSubmit(payload) {
    if (editing?.id) {
      await dispatch(statesThunks.updateOne({ id: editing.id, payload }));
      // refetch p/ garantir ordenação/estado atualizado
      dispatch(statesThunks.list({ q: q || "", limit, offset }));
      closeModal();
      return;
    }

    await dispatch(statesThunks.createOne(payload));
    dispatch(statesThunks.list({ q: q || "", limit, offset }));
    closeModal();
  }

  function onSearch() {
    dispatch(statesActions.clearError());
    dispatch(statesThunks.list({ q: q || "", limit, offset }));
  }

  const isLoading = status === "loading";

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
            States
          </h1>
          <p className="text-sm text-gray-500">{count} registro(s)</p>
        </div>

        <Button className="text-slate-600" onClick={openCreate}>
          Novo State
        </Button>
      </div>

      {error && (
        <Alert color="failure" onDismiss={() => dispatch(statesActions.clearError())}>
          {error}
        </Alert>
      )}

      <div className="flex items-center gap-2">
        <TextInput
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar por code ou name..."
        />
        <Button color="gray" onClick={onSearch} disabled={isLoading}>
          Buscar
        </Button>
      </div>

      <div className="border border-gray-200 dark:border-gray-800 rounded-lg overflow-hidden">
        {isLoading ? (
          <div className="p-6 flex items-center gap-3">
            <Spinner />
            <span className="text-sm text-gray-600 dark:text-gray-300">
              Carregando...
            </span>
          </div>
        ) : (
          <Table hoverable>
            <TableHead>
              <TableHeadCell>Code</TableHeadCell>
              <TableHeadCell>Name</TableHeadCell>
              <TableHeadCell>Default Regime</TableHeadCell>
              <TableHeadCell className="text-right">Ações</TableHeadCell>
            </TableHead>

            <TableBody className="divide-y">
              {items?.length ? (
                items.map((r) => (
                  <TableRow
                    key={r.id}
                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                  >
                    <TableCell className="font-medium text-gray-900 dark:text-white">
                      {r.code}
                    </TableCell>
                    <TableCell>{r.name}</TableCell>
                    <TableCell>{r.default_regime_type}</TableCell>
                    <TableCell className="text-right">
                      <Button size="xs" color="gray" onClick={() => openEdit(r)}>
                        Editar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} className="text-center py-6 text-gray-500">
                    Nenhum state encontrado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </div>

      <StateFormModal
        open={modalOpen}
        onClose={closeModal}
        initialData={editing}
        saving={isLoading} // simples: desabilita quando store está em loading
        onSubmit={onSubmit}
      />
    </div>
  );
}
